import { render, staticRenderFns } from "./20250403_pc.vue?vue&type=template&id=562474a7&scoped=true&"
import script from "./20250403_pc.vue?vue&type=script&lang=js&"
export * from "./20250403_pc.vue?vue&type=script&lang=js&"
import style0 from "./20250403_pc.vue?vue&type=style&index=0&id=562474a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562474a7",
  null
  
)

export default component.exports